import React, { useState } from 'react';
import axios from 'axios';

const ModalCreateServeur = ({ isVisible, onClose }) => {

    const [values, setValues] = useState({
        nom: '',
        url_serveur:'',
        version_serveur:''    
    })

    let error = document.getElementById('error');

    const handleClose = (e) => {  if(e.target.id === "wrapper") onClose(); }
    const handleSubmit = (e) => {
        e.preventDefault();
        error.innerHTML = '';
        if(values.nom === '' || values.url_serveur === '' || values.version_serveur === '' ){
            error.innerHTML = "Veuillez renseigner tout les champs"
        }else{
            axios.post(`${process.env.REACT_APP_IP}:${process.env.REACT_APP_PORT}/add_serveur`, values)
            .then(res => {
                // console.log(res);
                // navigate('/listusers');
                window.location.reload(false);
            }).catch(err => console.log(err))
        }
    }

    if( !isVisible ) return null;

    return (
        <div className='fixed inset-0 z-50 flex items-center justify-center bg-slate-900/50 backdrop-blur-sm p-4' id="wrapper" onClick={handleClose}>
            <div className='bg-white rounded-2xl shadow-2xl w-full max-w-lg max-h-[85vh] overflow-y-auto'>
                <div className="flex items-center justify-between border-b border-slate-200 px-6 py-4">
                    <h2 className="text-lg font-semibold text-slate-800">Nouveau serveur</h2>
                    <button type="button" className='flex h-8 w-8 items-center justify-center rounded-lg text-slate-400 hover:bg-slate-100 hover:text-slate-600' onClick={() => onClose()}>✕</button>
                </div>
                <form className="p-6" onSubmit={handleSubmit}>
                    <div className="mb-4">
                        <label htmlFor="nom" className="mb-1 block text-xs font-semibold uppercase tracking-wide text-slate-500">Nom serveur</label>
                        <input type="text" name="nom" id="nom" className="w-full rounded-lg border border-slate-300 bg-white px-3 py-2 text-sm text-slate-800 focus:border-indigo-500 focus:outline-none focus:ring-2 focus:ring-indigo-500/30" placeholder="Nom serveur" required  onChange={e => setValues({...values, nom: e.target.value})}/>
                    </div>
                    <div className="mb-4">
                        <label htmlFor="url_serveur" className="mb-1 block text-xs font-semibold uppercase tracking-wide text-slate-500">URL serveur</label>
                        <input type="text" name="url_serveur" id="url_serveur" className="w-full rounded-lg border border-slate-300 bg-white px-3 py-2 text-sm text-slate-800 focus:border-indigo-500 focus:outline-none focus:ring-2 focus:ring-indigo-500/30" placeholder="URL serveur" required  onChange={e => setValues({...values, url_serveur: e.target.value})}/>
                    </div>
                    <div className="mb-4">
                        <label htmlFor="version_serveur" className="mb-1 block text-xs font-semibold uppercase tracking-wide text-slate-500">Version serveur</label>
                        <input type="text" name="version_serveur" id="version_serveur" className="w-full rounded-lg border border-slate-300 bg-white px-3 py-2 text-sm text-slate-800 focus:border-indigo-500 focus:outline-none focus:ring-2 focus:ring-indigo-500/30" placeholder="Version serveur" required  onChange={e => setValues({...values, version_serveur: e.target.value})}/>
                    </div>
                    <button type="submit" className="rounded-lg bg-indigo-500 px-4 py-2 text-sm font-medium text-white hover:bg-indigo-600">Enregistrer</button>
                    <div className="py-4 text-center">
                        <p id="error" className='text-red-600'></p>
                    </div>
                </form>
            </div>
        </div>
    )
}

export default ModalCreateServeur;